/**
 *
 * FlexNavigator
 *
 */

import React, { useState, useRef } from 'react';
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

import { FormattedMessage } from 'react-intl';
import messages from './messages';
import styles from './flex-navigator.module.css';
import { Icon } from 'semantic-ui-react';

import {
  Switch,
  Route,
  withRouter,
  Link,
  useRouteMatch,
  useParams,
  useLocation,
} from 'react-router-dom';

function FlexNavigatorGroup(props) {
  const { group, visible } = props;
  let groupChildren = [];
  if (group.elements) {
    groupChildren = group.elements.map(childElem => {
      if (childElem.visible !== false) {
        if (childElem.component) {
          return childElem.component;
        }
      }
    });
  }

  if (visible === false) {
    return null;
  }
  return (
    <div className={`${styles.flex_navigator_group}`}>
      <div className={styles.flex_navigator_group_heading}>{group.title}</div>
      <div className={styles.flex_navigator_group_children}>
        {groupChildren}
      </div>
    </div>
  );
}

function FlexNavigator(props) {
  let {
    elements,
    style,
    basic = true,
    onChange,
    value,
    defaultValue,
    options,
    size,
    vertical,
  } = props;

  if (options && !elements) {
    elements = options;
  }

  let selectedHeadingElement;
  const timerRef = useRef({
    timer: null,
  });

  if (defaultValue) {
    defaultValue = elements.indexOf(
      elements.find(elem => elem.value === defaultValue),
    );
  }

  const [selectedIndex, setSelectedIndex] = useState(defaultValue);
  const [flowDirection, setFlowDirection] = useState('left');
  const [contentMinimized, setContentMinimized] = useState(false);

  const handleHeadingClicked = (elem, index, e) => {
    if (onChange) {
      onChange(elem);
    } else if (elem.onClick) {
      elem.onClick();
    }

    if (index < selectedIndex) {
      setFlowDirection('right');
    } else {
      setFlowDirection('left');
    }

    setSelectedIndex(index);
  };

  const handleMouseEnter = () => {
    setContentMinimized(false);
    if (timerRef.current && timerRef.current.timer) {
      clearTimeout(timerRef.current.timer);
    }
  };

  const handleMouseLeave = () => {
    // if (timerRef.current && timerRef.current.timer) {
    //   clearTimeout(timerRef.current.timer);
    // }
    // timerRef.current.timer = setTimeout(() => {
    //   setContentMinimized(true);
    // }, 1000);
  };

  const headingElements = elements.map((elem, index) => {
    if (elem.visible !== false) {
      if (elem.selected) {
        selectedHeadingElement = elem;
        if (selectedIndex === null) {
          setSelectedIndex(index);
        }
      }

      if (elem.type === 'link') {
        return (
          <Link
            key={elem.key}
            to={elem.route}
            onClick={handleHeadingClicked.bind(null, elem, index)}
            className={`${styles.flex_navigator_elem} ${
              value !== undefined && value === elem.value
                ? styles.nav_selected
                : elem.selected
                ? styles.nav_selected
                : ''
            }`}
          >
            {elem.icon && (
              <span
                className={`${styles.flex_navigator_elem_icon} material-icons`}
              >
                {elem.icon}
              </span>
            )}
            {elem.text}
          </Link>
        );
      } else if (elem.type === 'heading') {
        return (
          <div
            key={elem.key || index}
            className={styles.flex_navigator_heading}
          >
            {elem.text}
          </div>
        );
      } else {
        let selected = false;
        if (value) {
          selected = elem.value === value;
        } else if (elem.selected) {
          selected = elem.selected;
        } else {
          selected = selectedIndex === index;
        }
        return (
          <div
            key={elem.key}
            to={elem.route}
            onClick={handleHeadingClicked.bind(null, elem, index)}
            className={`${styles.flex_navigator_elem} ${
              selected ? styles.nav_selected : ''
            }`}
          >
            {elem.icon && (
              <span
                className={`${styles.flex_navigator_elem_icon} material-icons`}
              >
                {elem.icon}
              </span>
            )}
            {elem.text}
          </div>
        );
      }
    }
  });

  let selectedHeadingChildren = [];
  if (selectedHeadingElement) {
    if (selectedHeadingElement.elements) {
      selectedHeadingChildren = selectedHeadingElement.elements.map(
        childElem => {
          if (childElem.visible !== false) {
            if (childElem.component) {
              return childElem.component;
            } else if (childElem.group) {
              return <FlexNavigatorGroup group={childElem.group} />;
            }
          }
        },
      );
    }
  }

  let headingStyle = style ? style : {};

  return (
    <div
      style={headingStyle}
      className={styles.flex_navigator}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        className={`${styles.flex_navigator_headings} ${
          vertical ? styles.vertical : ''
        } ${basic ? styles.basic : ''} ${
          contentMinimized || selectedHeadingChildren.length === 0
            ? styles.minimized
            : ''
        }`}
      >
        {headingElements}
      </div>
      {selectedHeadingChildren.length > 0 && (
        <div
          key={selectedHeadingElement.key}
          className={`${styles.heading_element_children} ${
            contentMinimized ? styles.children_minimized : ''
          } ${flowDirection === 'left' ? styles.flow_left : styles.flow_right}`}
        >
          {selectedHeadingChildren}
        </div>
      )}
    </div>
  );
}

FlexNavigator.propTypes = {};

export default FlexNavigator;
